<template>
  <div>
    <div class="w-full py-2 mobile-Menu-container flex justify-between px-4">
      <div style="width: 100%;height: 100%;">
        <img src="@/assets/logoLefts.png" alt="logo" style="height: 70px;width: 300px"/>
      </div>
      <div class="w-10" @click="handleSetIsMenuVisible" style="line-height: 60px;height: 60px">
        <i class="el-icon-s-operation" v-if="!isMenuVisible" style="color: #176DAA;font-size: 36px;margin-top: 18px" ></i>
        <i class="el-icon-close" v-else style="color: #176DAA;font-size: 36px;margin-top: 18px"></i>
      </div>
    </div>
    <div class="mobile-actionsheet" v-show="isMenuVisible">
      <MobileMenu @setIsMenuVisible="handleSetIsMenuVisible" />
    </div>
  </div>
</template>

<script>
import MobileMenu from "./MobileMenu.vue";
export default {
  components: { MobileMenu },
  props: {
    isMenuVisible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleSetIsMenuVisible() {
      this.$emit("setIsMenuVisible", !this.isMenuVisible);
    },
  },
};
</script>

<style scoped>
.mobile-actionsheet {
  height: calc(100vh - 55px);
  overflow-y: auto;
  transition: 0.5s ease-out;
}
/* .mobile-Menu-container {
  background-image: url("~@/assets/logoBg.png");
  background-size: cover;
} */
</style>
